export default "__VITE_ASSET__DsXSOG5w__"